import React from "react";
import { CONTACT_EMAIL, CONTACT_PHONE } from "../data/mock";

const Section = ({ title, children }) => (
  <div className="mt-10">
    <h2 className="font-display font-extrabold text-xl md:text-2xl text-neutral-950 tracking-tight">
      {title}
    </h2>
    <div className="mt-3 text-neutral-700 leading-relaxed space-y-1.5">
      {children}
    </div>
  </div>
);

const ImpressumPage = () => {
  return (
    <section className="pt-36 md:pt-44 pb-24 md:pb-32 bg-white">
      <div className="max-w-[820px] mx-auto px-6 md:px-10">
        <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-neutral-100 border border-black/5 text-xs uppercase tracking-[0.2em] font-semibold text-neutral-700">
          Rechtliches
        </span>
        <h1 className="font-display font-bold text-5xl md:text-7xl tracking-[-0.04em] leading-[0.98] mt-6 text-neutral-950">
          Impressum
        </h1>
        <p className="mt-4 text-neutral-500 text-sm">
          Angaben zum Anbieter dieser Website.
        </p>

        <Section title="FREEAYTO">
          <p>Inhaber: Keanu Irle</p>
          <p>Erich Kästner Ring 23</p>
          <p>44339 Dortmund</p>
          <p>Deutschland</p>
        </Section>

        <Section title="Kontakt">
          <p>
            Telefon:{" "}
            <a
              href={`tel:${CONTACT_PHONE.replace(/\s/g, "")}`}
              className="underline hover:text-pink-500 transition-colors"
            >
              {CONTACT_PHONE}
            </a>
          </p>
          <p>
            E-Mail:{" "}
            <a
              href="mailto:k.irle@freeayto.de"
              className="underline hover:text-pink-500 transition-colors"
            >
              k.irle@freeayto.de
            </a>
          </p>
          <p>
            Allg. Anfragen:{" "}
            <a
              href={`mailto:${CONTACT_EMAIL}`}
              className="underline hover:text-pink-500 transition-colors"
            >
              {CONTACT_EMAIL}
            </a>
          </p>
        </Section>

        <Section title="Umsatzsteuer-ID">
          <p>
            Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:
          </p>
          <p className="font-mono font-semibold text-neutral-950">DE461970096</p>
        </Section>

        <Section title="Verantwortlich für den Inhalt">
          <p>Keanu Irle</p>
          <p>Erich Kästner Ring 23</p>
          <p>44339 Dortmund</p>
        </Section>

        <Section title="Haftung für Inhalte">
          <p>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt.
            Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
            können wir jedoch keine Gewähr übernehmen.
          </p>
        </Section>

        <Section title="Haftung für Links">
          <p>
            Unser Angebot enthält Links zu externen Websites Dritter, auf deren
            Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
            fremden Inhalte auch keine Gewähr übernehmen.
          </p>
        </Section>

        <Section title="Urheberrecht">
          <p>
            Die durch FREEAYTO erstellten Inhalte und Werke auf diesen Seiten
            unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind als
            solche gekennzeichnet.
          </p>
        </Section>
      </div>
    </section>
  );
};

export default ImpressumPage;
